<template>
	<section class="page page-subscribe">
		<ViewSubscriptionOffers v-on:select-plan="Handle_OnSelectPlan" v-on:subscribe="Handle_OnSubscribe" />
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Subscription page for selecting and purchasing premium plans.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageSubscribe extends PageBase {
		/**
		 * Handle plan selection event
		 *
		 * @param object payload
		 * @return void
		 */
		protected Handle_OnSelectPlan(payload: { cycle: string; plan: string }): void {
			ChalkySticks.Utility.Log.info('PageSubscribe', 'Plan selected:', payload);
		}

		/**
		 * Handle subscribe action
		 * This will be hooked up to RevenueCat SDK in the future
		 *
		 * @param object payload
		 * @return Promise<void>
		 */
		protected async Handle_OnSubscribe(payload: { cycle: string; plan: string }): Promise<void> {
			ChalkySticks.Utility.Log.info('PageSubscribe', 'Subscribe requested:', payload);

			// TODO: Map plan/cycle to RevenueCat package and initiate purchase
			// Example future implementation:
			// const packageId = this.mapToRevenueCatPackage(payload.plan, payload.cycle);
			// await ChalkySticks.Utility.Subscription.purchasePackage(packageId);

			ChalkySticks.Core.Event.Bus.dispatch('dialog:alert', {
				message: `You selected the ${payload.plan} plan (${payload.cycle}). Payment integration coming soon!`,
				title: 'Subscription',
			});
		}
	}
</script>

<style lang="scss">
	.page-subscribe {
		background-color: var(--chalky-blue-4);
		min-height: 100vh;
	}
</style>
